import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  TableCell,
  TableRow,
} from "@mui/material";
import { Colors } from "../../constants/Colors";
import Card from "../../components/Card";
import CustomTable from "../../components/Table";
import CustomButton from "../../components/Button";
import CustomInput from "../../components/Input";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { apiRequest } from "../../services/api-request";
import Pagination from "../../components/Pagination";
import { useAppContext } from "../../context/AppContext";

const dashboardHeader = [
  {
    id: 1,
    title: "S No.",
  },
  {
    id: 2,
    title: "Date",
  },
  {
    id: 3,
    title: "Buyer ID",
  },
  {
    id: 4,
    title: "Buyer Name",
  },
  {
    id: 5,
    title: "Seller ID",
  },
  {
    id: 6,
    title: "Seller Name",
  },
  {
    id: 7,
    title: "Seller Details",
  },
  {
    id: 8,
    title: "Animal Details",
  },
  {
    id: 9,
    title: "Transaction ID",
  },
  {
    id: 10,
    title: "Amount",
  },
  {
    id: 11,
    title: "Status",
  },
];

const UserTransactions = (props) => {
  const { user = {} } = useAppContext();
  const { animalId } = props;
  const [paymentList, setPaymentList] = useState({
    result: [],
    totalCount: "",
    loader: false,
  });

  const currentRole = user?.role?.code || null;

  const limit = 10;
  const [skip, setSkip] = useState(0);

  useEffect(() => {
    if(currentRole === 'mithunAdmin'){
      getLists({ skip, searchText: "" });
    }
  }, [skip]);

  const getLists = ({ skip, searchText }) => {
    setPaymentList({ loader: true });
    const payload = {
      skip: skip,
      limit: limit,
      limit: limit,
      ...(searchText && {
        searchText: searchText,
      }),
    };

    let search = searchText ? searchText : ''
    apiRequest({
      url: "mithun/get-ccavenuepayment-lists?search="+search+'&animal_id='+animalId,
      method: "GET",
      data: payload,
    })
      .then((res) => {
        setPaymentList({
          loader: false,
          totalCount: res.total_count ? res.total_count : res.data.length,
          result: res.data,
        });
      })
      .catch((err) => {
        setPaymentList({ loader: false });
      });
  };

  const handlePageChange = (pageNumber) => {
    const newSkip = (pageNumber - 1) * limit;
    setSkip(newSkip);
  };

  const TableDataUi = () => {
    return paymentList?.result?.map((row, index) => (
      <TableRow
        key={row.user_id}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {index + 1}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.date}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.buyer_id}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.buyer_name}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.seller_id}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.seller_name}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.seller_details}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.animal_details}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.transaction_id}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.amount}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.status}
          </Typography>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    currentRole === 'mithunAdmin' ?
    <Box>
      <Box mt={2}>
        <Card>
          <Box mt={2}>
            <CustomTable
              headerData={dashboardHeader}
              tableData={paymentList.result}
            >
              <TableDataUi />
            </CustomTable>
            <Box mt={2} display={"flex"} justifyContent={"right"}>
              {paymentList.totalCount > 10 && (
                <Pagination
                  totalCount={paymentList.totalCount}
                  skip={skip}
                  limit={limit}
                  onPageChange={handlePageChange}
                />
              )}
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>:
    <>
      <Box mt={2}>
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          // height={"80vh"}
        >
          <Grid item>
            <Typography
              fontFamily={"Poppins-Medium"}
              // color={Colors.headerColor}
              fontSize={16}
            >
              No Transactions Found
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default UserTransactions;
